import type { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  navType: 'prod',
  BACKEND_API_BASE_URL: 'https://api.stolt.com/st-aeye-backend-prod',
  AAD_CLIENT_ID: "99b09175-3a2d-47dd-9be3-9404e87dc3db",
  AAD_AUTHORITY: "https://login.microsoftonline.com/35d14ae1-4ee5-441b-a84a-6791dee05c7b",
  AAD_REDIRECT_URI: "https://aeye.stolttankers.com",
  AAD_GRAPH_ENDPOINT: 'https://graph.microsoft.com/v1.0/me',
  AAD_USER_API_SCOPE: 'api://7f73b65e-4f67-47bb-b64b-9e6453c3323f/.default',
  POSTHOG_API_KEY:'phc_u47UkcnXr5j39dsCUKibxpkejSLrBHD53FKciceTvwLE',
  POSTHOG_API_HOST:'https://ph.stolt.com',
  POSTHOG_UI_HOST: 'https://eu.posthog.com',
  POSTHOG_API_DEFAULTS: '2026-07-08',
  POSTHOG_ENABLED_TRACKING:true
};
